import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import LegalTravelAssistancePage from '@/components/pages/services/legalTravelAssistance';

const ProtectedLegalTravelAssistancePage = withAuthenticationRequired(
  LegalTravelAssistancePage,
  {
    onRedirecting: () => <Loading />,
  }
);

export const Route = createFileRoute('/services/legalTravelAssistance')({
  head: () => ({
    meta: [
      { title: `Legal Travel Assistance | ${activeConfig.branding.appName}` },
    ],
  }),
  component: ProtectedLegalTravelAssistancePage,
});
